import Axios from 'axios';
import { getHeaders } from '../../utills';
import AlertAction from '../Actions/AlertActions';
import GeneralAction from '../Actions/GeneralAction';
import ScheduleActions from '../Actions/ScheduleActions';
import TimeINTimeOUTActions from '../Actions/TimeINTimeOUTActions';
import Apis from '../Apis';


class StartJobMiddleware {

  static startJob = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('job_id', userData?.job_id);
          if (userData?.latitude) {
            formdata.append('latitude', userData?.latitude);
          }
          if (userData?.longitude) {
            formdata.append('longitude', userData?.longitude);
          }
          formdata.append('media_type', userData?.pickImage?.type?.match("video/*") ? 'video' : 'photo');
          formdata.append('before_attachment', userData?.pickImage);
          const { data } = await Axios.post(
            Apis.startJob,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static breakIn = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('job_id', userData?.job_id);
          if (userData?.latitude) {
            formdata.append('latitude', userData?.latitude);
          }
          if (userData?.longitude) {
            formdata.append('longitude', userData?.longitude);
          }
          const { data } = await Axios.post(
            Apis.breakIn,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static breakOut = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('job_id', userData?.job_id);
          if (userData?.latitude) {
            formdata.append('latitude', userData?.latitude);
          }
          if (userData?.longitude) {
            formdata.append('longitude', userData?.longitude);
          }
          formdata.append('after_lunch_attachment', userData?.pickImage);
          const { data } = await Axios.post(
            Apis.breakOut,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static getJobDetails = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {

        try {
          const { data } = await Axios.get(
            Apis.jobDetail + `${userData?.job_id}`,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static completeJob = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('job_id', userData?.job_id);
          formdata.append('rating', userData?.rating);
          formdata.append('note', userData?.note);
          formdata.append('report_problem', userData?.problem);
          if (userData?.latitude) {
            formdata.append('time_out_latitude', userData?.latitude);
          }
          if (userData?.longitude) {
            formdata.append('time_out_longitude', userData?.longitude);
          }
          formdata.append('media_type', userData?.pickImage?.type?.match("video/*") ? 'video' : 'photo');
          formdata.append('after_attachment', userData?.pickImage);
          for (const [i, document] of userData?.checklist.entries()) {
            formdata.append(`checklists[${i}]`, document);

          }
          const { data } = await Axios.post(
            Apis.jobComplete,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(TimeINTimeOUTActions.setTimeInImage(null))
            dispatch(TimeINTimeOUTActions.setLunchAfterImage(null))
            dispatch(TimeINTimeOUTActions.setTimeIN(null))
            dispatch(TimeINTimeOUTActions.setWorkIN('Time In'))
            dispatch(TimeINTimeOUTActions.setPlay(false))
            dispatch(TimeINTimeOUTActions.setDataMessage(null))
            dispatch(TimeINTimeOUTActions.setBreak(false))
            dispatch(TimeINTimeOUTActions.setBreakStartTime(null))
            dispatch(TimeINTimeOUTActions.setBreakIN('Break In'))
            resolve(data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

}

export default StartJobMiddleware;